<template>
  <div>
    <div v-if="$root.isDev">
      <van-button
        @click="
          $router.push({
            name: 'LuckyTurntable',
          })
        "
        size="mini"
        type="info"
        round
        >抽奖</van-button
      >
      <van-button
        @click="
          $router.push({
            name: 'GetCouponsCenter',
            query: { id: 299792492 },
          })
        "
        size="mini"
        type="info"
        round
        >领券中心</van-button
      >
      <van-button
        @click="$router.push({ name: 'ConsumeCodeInfo' })"
        size="mini"
        type="info"
        round
        >查看手牌</van-button
      >
      <van-button
        @click="$router.push('/SelfHelp/Micropoint')"
        size="mini"
        type="info"
        round
        >先进点餐页面，后扫餐台码</van-button
      >
      <van-button
        @click="
          $router.push(
            '/scanCode/takeNumberResult?action=takeorder&vpncode=QHCFZD&departid=299792612&tablecode=220720'
          )
        "
        size="mini"
        type="info"
        round
        >模拟普通点餐</van-button
      >
      <van-button
        @click="
          $router.push(
            '/scanCode/takeNumberResult?action=takeorder&p=QHCNCD,abc,838821,20000001,8001,01,1450'
          )
        "
        size="mini"
        type="info"
        round
        >模拟扫手牌绑定器点餐</van-button
      >
    </div>
    <select-store-entrance @sendVpnId="sendVpnId"></select-store-entrance>
    <g-swiper :images="topImages" :isPadding="true"></g-swiper>
    <!-- <myList></myList> -->
    <button-list-com></button-list-com>
    <member-com></member-com>
    <flashSale
      title="限时抢购"
      fromCom="timeLimit"
      v-if="flashSaleList.length > 0"
      :dataList="flashSaleList"
    ></flashSale>
    <!-- <flashSale
      title="拼团"
      fromCom="groupBuy"
      :dataList="groupBuyList"
    ></flashSale> -->
    <door-info></door-info>
    <!-- <all-list></all-list> -->

    <!-- <home-bottom></home-bottom> -->
    <g-bottom block></g-bottom>
    <g-back-to-top></g-back-to-top>
    <!-- <gCustomTabbar currentIdx="0"></gCustomTabbar> -->
  </div>
</template>

<script>
import selectStoreEntrance from "./comps/selectStoreEntrance";
import doorInfo from "./comps/doorInfo";
// import allList from "./comps/allList";
// import myList from "./comps/myList";
import buttonListCom from "./comps/buttonList";
import memberCom from "./comps/memberCom";
import flashSale from "./comps/flashSale.vue";
import { gHomeDatas } from "@/mock/gHome.js";
import { getProductList, tt } from "@/api/goods";

import homeBottom from "./comps/homeBottom";
import { toTel } from "u/gFunc.js";
import gHello from "c/globalComps/gHello";
import { getConsumerInfo, putConsumerInfo } from "@/api/user";
import { getGroupGoodsList } from "@/api/activity";

export default {
  name: "Index",
  props: {},

  components: {
    selectStoreEntrance,
    doorInfo,
    // allList,
    homeBottom,
    // myList,
    buttonListCom,
    memberCom,
    gHello,
    flashSale,
  },
  data() {
    return {
      isDev: "",
      myData: [],
      images: [],
      doorData: [],
      vpnId: "",
      // toScrollPosition: false,
      topImages: [
        "http://images01.wechat.goldenyun.cn/102071/36eac7e6-1693-478c-8809-45e874be465e/637703240602991143.jpg",
        // "http://images02.wechat.goldenyun.cn/102071/36eac7e6-1693-478c-8809-45e874be465e/637703244666744226.jpg",
      ],
      flashSaleList: [],
      groupBuyList: [],
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   try {
  //     next((vm) => {
  //       if (from.path === "/goods/shoppingCard") {
  //         vm.toScrollPosition = true;
  //       }
  //     });
  //   } catch (error) {
  //     console.warn("test环境下 vm报错");
  //     console.warn(error, "error");
  //   }
  // },
  beforeRouteLeave(to, from, next) {
    this.recordViewPortPosition();
    next();
  },
  created() {
    this.isDev = this.$root.isDev;
    this.myData = this.$pub.deepClone(gHomeDatas);
    let filterImgItem = this.myData.filter((v) => {
      return v.ModelCode === "Banner";
    });
    this.images = filterImgItem[0].ImageBanner.map((v) => {
      return v.Thumbnail;
    });
    this.doorInfo = this.myData.filter((v) => {
      return v.ModelCode === "VpnInfo";
    });
  },
  mounted() {
    // 刷新页面将记录的页面高度缓存清除
    let _this = this;
    // window.addEventListener("beforeunload", function(e) {
    //   _this.$store.commit('set_scrolltop', 0);
    // });
  },
  updated() {},
  methods: {
    sendVpnId(val) {
      this.vpnId = val;
      this.handleGetLimitGoods();
      this.handleGetGroupBuyGoods();
    },

    // 离开首页时记录距离顶部的位置，存到sessionStorage里，方便回来时取用
    recordViewPortPosition() {
      this.$store.commit("set_scrolltop", window.pageYOffset);
    },
    // 将doorInfo接口请求得到的images数据发送出来
    sendTopImages(val) {
      // this.topImages = val.images;
    },
    handleGetLimitGoods() {
      let params = {
        query: {
          // vpnId: '299792465',
          VpnId: this.vpnId,
          EventTypeId: 3,
          // type: this.activeTabName,
        },
        pager: {
          pageindex: 0,
          pagesize: 500,
        },
      };
      getGroupGoodsList(params)
        .then((res) => {
          let data = res.Items;
          this.flashSaleList = data;
        })
        .catch((err) => {});
      // const res = [
      //   {
      //     GoodsName: "哪家快递师傅i",
      //     Price: 199,
      //     GoodsDetailExplain: "这个不错哈哈哈",
      //     Number: 3,
      //     OriginPrice: 269,
      //     StatusMsg: "进行中",
      //     SurplusNum: 10,
      //     EndTime: "2022-07-13T17:05:56",
      //   },
      // ];
      // res.forEach((item) => {
      //   let timeNum = new Date(item.EndTime) - new Date();
      //   console.log(new Date(item.endTime));
      //   console.log("================" + timeNum);
      //   item.time = timeNum;
      // });
      // this.flashSaleList = res;
    },
    handleGetGroupBuyGoods() {
      const res = [
        {
          GoodsName: "拼团套餐",
          Price: 99,
          GoodsDetailExplain: "这是一个拼团套餐",
          Number: 10,
          OriginPrice: 139,
          StatusMsg: null,
          SurplusNum: 10,
          endTime: "2022-07-20T17:05:56",
        },
      ];
      res.forEach((item) => {
        let timeNum = new Date(item.endTime) - new Date();
        item.time = timeNum;
      });
      this.groupBuyList = res;
    },
  },
};
</script>
<style scoped lang="scss"></style>
